// Display helper: legacy orders were numbered MWO-YYYY-#### — show them as MO-.
export const moNum = (s) => (s || "").replace(/^MWO-/, "MO-");
